// src/components/TargetDateChips.jsx
//
// "2 due today" and "5 overdue", as two chips that also filter.
//
// The row tint answers "is this one late" while you are looking at a row. It
// does not answer "is anything late", which is the question somebody opens the
// screen with — and forty rows deep, a tint eight rows below the fold answers
// nothing at all. The counts sit in the header where that question is asked.
//
// A chip with a zero is not rendered. A permanent "0 overdue" is a thing the
// eye learns to skip, and then fails to notice on the day it says 3.
import React from "react";

import StatChip from "./StatChip";

const TargetDateChips = ({ counts, mode, onToggle }) => {
  if (!counts) return null;

  const { due = 0, overdue = 0 } = counts;
  if (!due && !overdue) return null;

  return (
    <>
      {overdue > 0 && (
        <StatChip
          icon="bi-exclamation-triangle-fill"
          tone="red"
          label="Overdue"
          value={overdue}
          active={mode === "overdue"}
          onClick={() => onToggle("overdue")}
          title={
            mode === "overdue"
              ? "Showing only tasks past their target date — press to show all"
              : "Show only tasks past their target date"
          }
        />
      )}

      {due > 0 && (
        <StatChip
          icon="bi-alarm-fill"
          tone="amber"
          label="Due today"
          value={due}
          active={mode === "due"}
          onClick={() => onToggle("due")}
          title={
            mode === "due"
              ? "Showing only tasks due today — press to show all"
              : "Show only tasks due today"
          }
        />
      )}
    </>
  );
};

export default TargetDateChips;
